<template>
  <div
    class="image-text-nav"
    :style="{
      marginLeft: ($$FormData.page_edge ) * 0.5 + 'px',
      marginRight: ($$FormData.page_edge ) * 0.5 + 'px',
      backgroundColor: $$FormData.background_color,
      borderRadius: ($$FormData.page_radius ) * 0.5 + 'px',
      '--dot-color-active': $$FormData.swiper_color,
      outlineColor: $$FormData.border_color
    }"
  >
    <template v-if="$$FormData.nav_style === 'more-swiper'">
      <div
        v-if="$$FormData.navList.length"
        :class="['image-text-nav__swiper']"
      >
        <swiper :options="swiperOptions">
          <swiper-slide v-for="(swiperItem, index) in swiperNavList" :key="index">
            <div
              v-for="item in swiperItem"
              :key="item.__key"
              class="image-text-nav__item"
              :style="{
                width: (itemSize ) * 0.5 + 'px',
                color: $$FormData.text_color,
                paddingTop: 0
              }">
              <div
                v-if="$$FormData.nav_type === 'image-text'"
                class="image-text-nav__image"
                :style="{
                width: (itemSize * $$FormData.image_scale ) * 0.5 + 'px',
                height: (itemSize * $$FormData.image_scale ) * 0.5 + 'px',
                backgroundImage: `url(${item.image.src || default_image})`,
                borderRadius: ($$FormData.image_radius ) * 0.5 + 'px',
              }"
              />
              <div v-if="item.title" class="image-text-nav__title">{{ item.title }}</div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div v-else class="image-text-nav__empty">
        请添加导航
      </div>
    </template>
    <template v-else-if="$$FormData.nav_style === 'more-scroll'">
      <div
        v-if="$$FormData.navList.length"
        :class="['image-text-nav__nav', 'image-text-nav__scroll']"
      >
        <div
          v-for="(scrollItem, scrollIndex) in scrollNavList"
          :key="scrollIndex"
          class="image-text-nav__item"
          :style="{
            width: (itemSize ) * 0.5 + 'px',
            color: $$FormData.text_color
          }">
          <div v-for="(item, itemIndex) in scrollItem" :key="itemIndex" :class="!itemIndex && 'first-item'">
            <div
              v-if="$$FormData.nav_type === 'image-text'"
              class="image-text-nav__image"
              :style="{
                width: (itemSize * $$FormData.image_scale ) * 0.5 + 'px',
                height: (itemSize * $$FormData.image_scale ) * 0.5 + 'px',
                backgroundImage: `url(${item.image.src || default_image})`,
                borderRadius: ($$FormData.image_radius ) * 0.5 + 'px',
              }"
            />
            <div v-if="item.title" class="image-text-nav__title">{{ item.title }}</div>
          </div>
        </div>
        <div v-if="$$FormData.navList.length > $$FormData.nav_show_num * 2" class="scroll-bar">
          <div class="left-line" :style="{ background: $$FormData.scroll_color }"></div>
        </div>
      </div>
      <div v-else class="image-text-nav__empty">
        请添加导航
      </div>
    </template>
    <template v-else>
      <div
        v-if="$$FormData.navList.length"
        :class="['image-text-nav__nav', $$FormData.nav_type, $$FormData.nav_style === 'peer-fixed' && 'image-text-nav__peer-fixed']"
        :style="{
          overflowX: $$FormData.nav_style === 'fixed' || $$FormData.nav_style === 'more'  ? 'hidden' : 'auto',
          display: $$FormData.nav_style === 'more' ? 'contents' : (($$FormData.nav_style === 'peer-fixed' || $$FormData.nav_style === 'fixed') ? 'flex' : 'block'),
          margin: ($$FormData.page_margin_edge ) * 0.5 + 'px',
          borderRadius: ($$FormData.page_margin_radius ) * 0.5 + 'px',
          borderColor: $$FormData.margin_border_color
        }">
        <div
          v-for="(item, itemIndex) in $$FormData.navList"
          :key="item.__key"
          class="image-text-nav__item"
          :style="{
            width: (itemSize ) * 0.5 + 'px',
            color: $$FormData.text_color,
            paddingTop: $$FormData.nav_style === 'peer-fixed' ? '10px' : ($$FormData.nav_style !== 'fixed' && itemIndex > ($$FormData.nav_show_num - 1) ? 0 : '10px')
          }">
          <div
            v-if="$$FormData.nav_type === 'image-text'"
            class="image-text-nav__image"
            :style="{
            width: (itemSize * $$FormData.image_scale ) * 0.5 + 'px',
            height: (itemSize * $$FormData.image_scale ) * 0.5 + 'px',
            backgroundImage: `url(${item.image.src || default_image})`,
            borderRadius: ($$FormData.image_radius ) * 0.5 + 'px',
          }"
          />
          <div v-if="item.title" class="image-text-nav__title">{{ item.title }}</div>
        </div>
      </div>
      <div v-else class="image-text-nav__empty">
        请添加导航
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ImageTextNavPreview',
  data() {
    return {
      default_image: require('@/assets/placeholder-image-text-nav-image.png'),
      swiperOptions: {
        loop: true,
        autoplay: false,
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },
  computed: {
    itemSize() {
      const { navList, nav_style, page_edge, nav_show_num } = this.$$FormData
      if (nav_style === 'fixed') return `${(750 - page_edge * 2) / navList.length}`
      return `${(750 - page_edge * 2) / nav_show_num}`
    },
    swiperNavList() {
      const { navList, nav_show_num } = this.$$FormData
      if (navList && navList.length) {
        return this.chunkArr(navList, nav_show_num * 2)
      } else {
        return navList
      }
    },
    scrollNavList() {
      const { navList } = this.$$FormData
      console.log(this.chunkArr(navList, 2))
      if (navList && navList.length) {
        return this.chunkArr(navList, 2)
      } else {
        return navList
      }
    }
  },
  methods: {
    // 拆分数据
    chunkArr(arr, size) {
      if (!arr.length || size < 1) return []
      let [start, end, result] = [null, null, []]
      for (let i = 0; i < Math.ceil(arr.length / size); i++) {
        start = i * size
        end = start + size
        result.push(arr.slice(start, end))
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.image-text-nav {
  overflow: hidden;
  font-size: 0;
  outline: 1px solid;
  border: none;
  &__nav {
    margin-bottom: -10px;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    border: 1px solid;
  }
  &__item {
    display: inline-block;
    overflow: hidden;
    padding: 10px 0;
  }
  &__image {
    display: block;
    width: 100%;
    margin: 0 auto;
    border: 0;
    background-position: 50%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  &__title {
    box-sizing: border-box;
    overflow: hidden;
    width: 100%;
    margin-top: 5px;
    font-size: 12px;
    line-height: normal;
    text-align: center;
  }
  &__empty {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    color: #7D7D80;
    font-size: 18px;
    background-color: #909399;
  }
  &__swiper {
    /deep/ .swiper-container {
      padding: 10px 0;
      &-bullet {
        bottom: 5px;
      }
      .swiper-pagination-bullet-active {
        background-color: var(--dot-color-active) !important;
      }
    }
  }
  &__scroll {
    overflow-x: auto;
    .image-text-nav__item {
      display: inline-table;
    }
    .first-item {
      padding-bottom: 10px;
    }
    .scroll-bar {
      background: #d6d6d6;
      height: 4px;
      width: 24px;
      border-radius: 3px;
      position: relative;
      left: 50%;
      transform: translate(-50%, 0);
      z-index: 9;
      bottom: 0;
      transition: all 0.5s ease-in;
      margin-bottom: 8px;
      .left-line {
        content: ' ';
        width: 12px;
        height: 4px;
        border-radius: 3px;
        position: absolute;
        top: 0;
      }
    }
  }
  &__peer-fixed {
    display: flex;
    align-items: center;
    justify-items: center;
    padding-bottom: 0;
    .image-text-nav__item {
      display: flex;
      align-items: center;
      justify-items: center;
      margin-left: 8px;
      .image-text-nav__title {
        margin: 0 5px;
        text-align: left;
      }
    }
  }
}
</style>
